/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseVideoFragment, VideoFragment, FullVideoFragment} from '@amblique/contentful/app/contentful/fragments/video';

/**
 * Get a single Video by ID (base - scalars only)
 */
export const getBaseVideoById = gql`
  ${BaseVideoFragment}

  query GetBaseVideoById($id: String!, $locale: String!, $preview: Boolean) {
    video(id: $id, locale: $locale, preview: $preview) {
      ...BaseVideoFragment
    }
  }
`;

/**
 * Get a single Video by ID (standard - 1 level deep)
 */
export const getVideoById = gql`
  ${VideoFragment}

  query GetVideoById($id: String!, $locale: String!, $preview: Boolean) {
    video(id: $id, locale: $locale, preview: $preview) {
      ...VideoFragment
    }
  }
`;

/**
 * Get a single Video by ID (full - 2 levels deep)
 */
export const getFullVideoById = gql`
  ${FullVideoFragment}

  query GetFullVideoById($id: String!, $locale: String!, $preview: Boolean) {
    video(id: $id, locale: $locale, preview: $preview) {
      ...FullVideoFragment
    }
  }
`;

/**
 * Get all Video entries with pagination (base - scalars only)
 */
export const getBaseVideos = gql`
  ${BaseVideoFragment}

  query GetBaseVideos(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [VideoOrder]
    $where: VideoFilter
    $preview: Boolean
  ) {
    videoCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseVideoFragment
      }
    }
  }
`;

/**
 * Get all Video entries with pagination (standard - 1 level deep)
 */
export const getVideos = gql`
  ${VideoFragment}

  query GetVideos(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [VideoOrder]
    $where: VideoFilter
    $preview: Boolean
  ) {
    videoCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...VideoFragment
      }
    }
  }
`;

/**
 * Get all Video entries with pagination (full - 2 levels deep)
 */
export const getFullVideos = gql`
  ${FullVideoFragment}

  query GetFullVideos(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [VideoOrder]
    $where: VideoFilter
    $preview: Boolean
  ) {
    videoCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullVideoFragment
      }
    }
  }
`;
